import { StyledItemContainer, StyledItemsContainer, StyledSkeleton } from "./StyledComponents";

/**
 * add-to-playlist modal content skeleton
 */
export const AddToPlaylistSkeleton = () => {
    const textWidths = [137, 94, 56, 193, 137];

    const skeletonItems = Array.from(
        { length: 5 },
        (_, index) => (
            <StyledItemContainer key={`item-${index + 1}`}>
                <StyledSkeleton variant="rectangular" width={18} height={18} />
                <StyledSkeleton variant="rectangular" width={textWidths[index]} height={18} />
            </StyledItemContainer>
        )
    );

    return <StyledItemsContainer>{skeletonItems}</StyledItemsContainer>;
};
